import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import {
    ConfigurationAutomaticBillableConceptRuleEntityType,
    ConfigurationAutomaticBillableConceptRuleResponse
} from '@/modules/configurationModule/detail/automation/billable-concepts/components/services/configuration-automatic-billable-concept/configuration-automatic-billable-concept-rule.dto'
import i18n from '@/lang/i18n'
import { ColDef } from '@ag-grid-enterprise/all-modules'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { configurationAutomaticBillableConceptRuleService } from '@/modules/configurationModule/detail/automation/billable-concepts/components/services/configuration-automatic-billable-concept/configuration-automatic-billable-concept-rule.service'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'
import { getEntityStatusStateColumnGridOptions } from '@/grid/base-grid-options'

export const ConfigurationAutomaticBillableConceptRulesColumnDefs =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            ...getEntityStatusStateColumnGridOptions(Object.values(ConfigurationAutomaticBillableConceptRuleEntityType)),
            headerName: i18n.tc('configuration.grid.automationType'),
            field: 'entityType',
            minWidth: 250,
            width: 110,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.concept'),
            field: 'concept.name',
            minWidth: 250,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: `${i18n.t('configuration.grid.code')} (${i18n.tc('configuration.sections.concept')})`,
            field: 'concept.code',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.caseTypes'),
            field: 'caseType.description',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.procedures'),
            field: 'procedure.description',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.location'),
            field: 'topographicCode.description',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.sampleType'),
            field: 'sampleType.description',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.mostLikelyDiagnoses'),
            field: 'mostLikelyMorphologicCode.description',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.protocol'),
            field: 'protocol.prtName',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.assay'),
            field: 'assay.name',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.NUMBER,
            headerName: i18n.tc('configuration.grid.priority'),
            field: 'rulePriority',
            minWidth: 150,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationAutomaticBillableConceptsGridState extends CrudModelPaginatorLaboratory<ConfigurationAutomaticBillableConceptRuleResponse> {
    service: typeof configurationAutomaticBillableConceptRuleService
    laboratoryId: number
}
export const initialConfigurationAutomaticBillableConceptsGridState =
    (): ConfigurationAutomaticBillableConceptsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.automaticbillableconceptrules',
        columnsDef: ConfigurationAutomaticBillableConceptRulesColumnDefs(),
        datasource: new PaginatorLaboratoryDatasource(configurationAutomaticBillableConceptRuleService, store.getters.labId),
        service: configurationAutomaticBillableConceptRuleService,
        laboratoryId: store.getters.labId
    })
